import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mapbox = defineConnector({
  identifier: "mapbox",
  name: "Mapbox",
  tagLine: "Maps, geocoding, and navigation APIs",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.mapbox\\.com/.*",
  auth: (app) =>
    queryAuth([{ name: "access_token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Create an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Tokens](https://account.mapbox.com/access-tokens/) in your Mapbox account and create an access token, or copy your default public token.",
        },
      ],
    },
    {
      title: "Copy and paste the access token into the field below",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.mapbox.com/search/geocode/v6/forward?q=Los%20Angeles",
  },
});
